import { ScaffolderInputHeader } from '@internal/plugin-scaffolder-common-field-react';
import React from 'react';

import { Box, TextField, Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

import { NAMESPACE_INFO } from '../infoDoc';
import { useStyles } from '../styles';

interface NamespaceInputProps {
  formData: string[];
  onChange: (data: string[]) => void;
  rawErrors: string[];
  maxNamespaces?: number;
  disabled?: boolean;
}

export const NamespaceInput = (props: NamespaceInputProps) => {
  const {
    onChange,
    formData,
    rawErrors,
    maxNamespaces = 10,
    disabled = false,
  } = props;
  const classes = useStyles();

  const handleAddNamespace = () => {
    onChange([...formData, '']);
  };

  const handleNamespaceChange = (index: number, value: string) => {
    const newNamespaces = [...formData];
    newNamespaces[index] = value;
    onChange(newNamespaces);
  };

  const handleRemoveNamespace = (index: number) => {
    const newNamespaces = formData.filter((_, i) => i !== index);
    onChange(newNamespaces);
  };

  const hasMaxItems = formData ? formData.length < maxNamespaces : false;

  return (
    <Box>
      <ScaffolderInputHeader
        title="Namespaces"
        description="List of namespaces allowed to use for deploying applications to the cluster."
        infoDoc={NAMESPACE_INFO}
      />
      {formData.map((namespace, index) => (
        <Box key={index} className={classes.flexContainer}>
          <Box className={classes.inputContainer}>
            <TextField
              label="Namespace"
              fullWidth
              variant="outlined"
              color="secondary"
              size="small"
              placeholder="Enter namespace or namespace pattern, e.g. dev-*"
              required
              value={namespace}
              onChange={e => handleNamespaceChange(index, e.target.value)}
              disabled={disabled}
              error={Boolean(rawErrors?.length > 0) && formData.length === 0}
            />
          </Box>
          <Box marginBottom={2}>
            <Button
              variant="outlined"
              color="secondary"
              disabled={disabled}
              onClick={() => handleRemoveNamespace(index)}
            >
              Remove
            </Button>
          </Box>
        </Box>
      ))}
      <Button
        startIcon={<AddIcon />}
        onClick={handleAddNamespace}
        color="secondary"
        disabled={disabled || (formData && !hasMaxItems)}
      >
        Add Namespace
      </Button>
    </Box>
  );
};
